<template>
  <section class="contact" data-aos="fade-up">
    <h2 class="section-title">Contato</h2>
    <p class="section-subtitle">
      Me conte sobre o seu projeto. Retorno o contato o mais rápido possível.
    </p>

    <div class="contact-grid">
      <div class="contact-card">
        <h3>Fale comigo</h3>
        <p>
          Se você precisa de um site, sistema web, integração ou quer modernizar
          um processo da sua empresa, podemos conversar sem compromisso.
        </p>

        <ul class="contact-list">
          <li>
            <span class="label">E-mail</span>
            <a href="mailto:contato@pradosweb.com.br">
              contato@pradosweb.com.br
            </a>
          </li>
          <li>
            <span class="label">WhatsApp</span>
            <a href="https://wa.me/5516993421030" target="_blank" rel="noopener">
              +55 (16) 99342-1030
            </a>
          </li>
        </ul>
      </div>

      <form class="contact-form" @submit.prevent="handleSubmit">
        <div class="field-group">
          <label for="nome">Nome</label>
          <input id="nome" v-model="form.nome" type="text" required />
        </div>

        <div class="field-group">
          <label for="email">E-mail</label>
          <input id="email" v-model="form.email" type="email" required />
        </div>

        <div class="field-group">
          <label for="tipo">Tipo de projeto</label>
          <select id="tipo" v-model="form.tipo" required>
            <option value="">Selecione</option>
            <option>Site institucional</option>
            <option>Landing page</option>
            <option>Sistema web</option>
            <option>Integração / automação</option>
            <option>Outro</option>
          </select>
        </div>

        <div class="field-group">
          <label for="mensagem">Mensagem</label>
          <textarea
            id="mensagem"
            v-model="form.mensagem"
            rows="4"
            required
          ></textarea>
        </div>

        <button type="submit" class="btn btn-primary">
          Enviar mensagem
        </button>

        <p v-if="enviado" class="contact-feedback">
          Mensagem enviada (simulação). Depois podemos integrar com EmailJS ou
          backend em PHP/.NET.
        </p>
      </form>
    </div>
  </section>
</template>

<script setup>
import { reactive, ref } from "vue";

const form = reactive({
  nome: "",
  email: "",
  tipo: "",
  mensagem: "",
});

const enviado = ref(false);

const handleSubmit = () => {
  // Aqui depois dá pra integrar com EmailJS ou uma API em PHP / .NET
  enviado.value = true;
  setTimeout(() => {
    enviado.value = false;
  }, 4000);
};
</script>

<style scoped>
.contact {
  padding: 2.2rem 0 3rem;
}

.contact-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(0, 1.2fr);
  gap: 2.2rem;
  align-items: flex-start;
}

/* Card de informações */
.contact-card {
  border-radius: var(--pw-radius-xl);
  border: 1px solid rgba(148, 163, 184, 0.38);
  background: radial-gradient(circle at 0 0, #0b1120, #020617);
  padding: 1.4rem 1.45rem;
  box-shadow: var(--pw-shadow-soft);
}

.contact-card h3 {
  margin: 0 0 0.6rem;
  font-size: 1.05rem;
}

.contact-card p {
  margin: 0 0 1rem;
  color: var(--pw-muted);
  font-size: 0.95rem;
}

.contact-list {
  list-style: none;
  margin: 0;
  padding: 0;
  font-size: 0.9rem;
}

.contact-list li + li {
  margin-top: 0.5rem;
}

.contact-list .label {
  display: block;
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  color: rgba(148, 163, 184, 0.95);
}

.contact-list a {
  color: rgba(191, 219, 254, 0.95);
  text-decoration: none;
}

/* Formulário */
.contact-form {
  border-radius: var(--pw-radius-xl);
  border: 1px solid rgba(148, 163, 184, 0.35);
  background: linear-gradient(
    135deg,
    rgba(15, 23, 42, 0.95),
    rgba(15, 23, 42, 0.75)
  );
  padding: 1.4rem 1.45rem 1.5rem;
  box-shadow: var(--pw-shadow-soft);
}

.field-group {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-bottom: 0.9rem;
}

label {
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: rgba(209, 213, 219, 0.9);
}

input,
select,
textarea {
  border-radius: 12px;
  border: 1px solid rgba(51, 65, 85, 0.8);
  padding: 0.55rem 0.7rem;
  background: rgba(15, 23, 42, 0.9);
  color: #e5e7eb;
  font-size: 0.9rem;
  outline: none;
}

input:focus,
select:focus,
textarea:focus {
  border-color: rgba(129, 140, 248, 0.9);
  box-shadow: 0 0 0 1px rgba(56, 189, 248, 0.3);
}

textarea {
  resize: vertical;
}

.contact-feedback {
  margin-top: 0.7rem;
  font-size: 0.8rem;
  color: rgba(190, 242, 100, 0.95);
}

/* Responsivo */
@media (max-width: 960px) {
  .contact-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}
</style>
